export default "__VITE_ASSET__CnFd6YgR__"